import React from "react";
import Messaging from "../Components/Messaging";

export default function Message() {
    return (
        <div>
            <Messaging/>
        </div>
    )
}